module.exports = __webpack_public_path__ + "static/media/hinge.b1c0283f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/hinge.png
// module id = 1220
// module chunks = 0